$(document).ready(function() {

	// Setup primary nav hovers
	$('<div id="main-nav-overlay"></div>').css({
		position: 'absolute',
		top: 0,
		left: 0,
		width: '100%',
		'z-index': 1,
		display: 'none',
		background: '#000',
		opacity: 0.5
	}).appendTo(document.body);
	$('#primary-nav li').each(function(i, el) {

		// Position block
		var li = $(this);
		var ul = li.parent('ul');
		var ddWrap = li.find('div.dd-wrap');
		ddWrap.css('left', 30-li.position(ul).left);

		// Add hover functionality
		li.hover(function() {	/* Over */
			var li = $(this);
			var ddWrap = li.find('div.dd-wrap');
			if(ddWrap.size()>0) {
				$('#main-nav-overlay').css({
					height: $(document.body).height(),
					display: 'block'
				});
				li.addClass('hover');
			}
		}, function() {	/* Out */
			var li = $(this);
			var ddWrap = li.find('div.dd-wrap');
			if(ddWrap.size()>0) {
				$('#main-nav-overlay').css({
					display: 'none'
				});
				li.removeClass('hover');
			}
		});
	});

	// Add hovers to featured nav on homepage
	$('#featured-nav li div').each(function(i, el) {
		$(this).css({
			bottom: -$(this).outerHeight(),
			opacity: 0.8
		});
	});
	$('#featured-nav li').hover(function() {
		$(this).find('div').animate({bottom:0});
	}, function() {
		$(this).find('div').animate({bottom:-$(this).find('div').outerHeight()});
	}).click(function() {
		self.location = $(this).find('a').attr('href');
	});

	// Setup filter sliders
	$('.filter-slider').each(function(i, el) {
		new FilterSlider($(el));
	});

	// Setup show/hide handlers on fairtrade map (page-fairtrade.html)
	window.__currentFairtradePlot = null;
	$('ul#map-info li').css('display', 'none');
	$('li[rel=fairtrade-plots] area').click(function() {

		// Get plot ref
		var plot = $(this).attr('href').replace(/^#/, '');

		// Hide current plot
		if(window.__currentFairtradePlot!==null) {
			$('ul#map-info li[rel='+window.__currentFairtradePlot+']').stop().css({opacity:1, display:'block'}).animate({opacity: 0}, function(){
				$(this).css('display', 'none');
				window.__currentFairtradePlot = plot;
				$('ul#map-info li[rel='+plot+']').stop().css({opacity:0, display:'block'}).animate({opacity: 1});
			});
		}

		// Show plot
		else {
			window.__currentFairtradePlot = plot;
			$('ul#map-info li[rel='+plot+']').stop().css({opacity:0, display:'block'}).animate({opacity: 1});
		}
		return false;
	});

	// Add handler to "Add to cart" button
	$('input#purchase').click(function() {

		// Show black overlay
		$('#main-nav-overlay').css({
			height: $(document.body).height(),
			display: 'block'
		});

		// Display modal box
		$('div#buy-modal').css({
			top: $(document).scrollTop() + 100,
			left: Math.round(($(document.body).width()-$('div#buy-modal').width())/2),
			display: 'block'
		});

		// Cancel bubble
		return false;
	});

	// Add some handlers to the filters in the "set diamonds" UI which will alter
	// the price field depending on which filters are chosen
	$('form#diamond-search ul.filter li a').click(function() {

		// Toggle the active state to indicate if this filter is in affect or not
		if($(this).hasClass('filter-active')) {
			$(this).removeClass('filter-active');
		}
		else {
			$('a[rel='+$(this).attr('rel')+']').removeClass('filter-active');
			$(this).addClass('filter-active');
		}

		// Gather all filters that are selected
		var activeFilters = $('form#diamond-search ul.filter li a.filter-active');

		// Calculate price from selected filters
		// NOTE: At present this will just throw a random price in the field
		$('input#price').val(Math.round(Math.random(100, 500)*100000)/100);

		// Cancel bubble
		return false;
	});

	// Toggles for origin content
	$('a[rel=group-origin]').click(function() {
		$('#info-'+$(this).attr('id').replace(/^btn\-/, '')).removeClass('hide').show().siblings('div').hide();
		return false;
	});
	
	// same page scrolling
	$.localScroll();	
	
});



/**
* To create a min/max value slider, add the inputs:
*		<input type="hidden" rel="range" value="min,max" />
*		<input type="text" rel="min" value="" />
*		<input type="text" rel="max" value="" />
*
* To create a fixed-option slider, add the inputs:
*		<select multiple="multiple">
*			<option value="">Label</option>
*			...
*		</select>
*
* You can also add an options via inputs, eg:
*		<input type="hidden" rel="option" name="optionName" value="optionValue" />
*
* @param HtmlElement The element containing the slider inputs
*/
var FilterSlider = function(elContainer) {

	// Determine what type of slider it is
	this.type = elContainer.find('select').size()>0 ? 'option' : 'range';

	// Create the core elements
	this.snap = 1;
	this.showSnapGuides = false;
	this.wrap = $('<div class="filter-slider"></div>').appendTo(elContainer);
	this.bar = $('<div class="filter-slider-bar"></div>').data('fs', this).appendTo(this.wrap);
	this.handleMin = $('<div class="filter-slider-handle filter-slider-min"></div>').data('fs', this).appendTo(this.bar);
	this.handleMax = $('<div class="filter-slider-handle filter-slider-max"></div>').data('fs', this).appendTo(this.bar);
	this.labelContainer = $('<div class="clear filter-slider-labels"></div>').appendTo(this.wrap);

	// Create elements for "range" type
	if(this.type=='range') {
		var r = elContainer.find('input[rel=range]').val().replace(/\s/g, '').split(',');
		this.lower = parseFloat(r[0]);
		this.upper = parseFloat(r[1]);
		this.lowerInput = $(elContainer).find('input[rel=min]').addClass('filter-slider-lower-input').appendTo(this.labelContainer);
		this.upperInput = $(elContainer).find('input[rel=max]').addClass('filter-slider-upper-input').appendTo(this.labelContainer);
	}

	// Create elements for "option" types
	if(this.type=='option') {
		this.optionInput = $(elContainer.find('select')).css('display', 'none');
		this.snap = this.bar.width()/this.optionInput.find('option').length;
		this.showSnapGuides = true;
		var opts = this.optionInput.find('option');
		var sum = 0;
		for(var i=0; i<opts.length; i++) {
			$('<div class="filter-slider-label"></div>').html($(opts[i]).html()).css({left: Math.round(sum), width:Math.round(this.snap)}).appendTo(this.labelContainer);
			sum += this.snap;
		}
	}

	// Render snap guides
	if(this.showSnapGuides) {
		var bw = this.bar.width();
		for(var i=this.snap; i<bw; i+=this.snap) {
			$('<div class="filter-slider-snap-guide"></div>').css('left', i-2).appendTo(this.bar);
		}
	}

	// Set the initial handle positions based on the input values
	this.setHandlesFromInputs();

	// Add drag mechanics to handles
	var _fs = this;
	$(document.body).mousemove(function(ev) {

		// Vars
		var hw = _fs.handleMin.width()-2;
		var lMax = _fs.bar.width()-_fs.handleMax.width();
		var lMin = 0;
		var isDrag = false;

		// Drag min handle
		if(_fs.handleMin.data('isdrag')===true) {
			isDrag = true;
			var pos = Math.floor(ev.pageX-_fs.bar.position().left);
			var ll = Math.min(Math.max(0, pos), _fs.handleMax.position().left-hw);
			ll = Math.floor(ll/_fs.snap)*_fs.snap;
			_fs.handleMin.css('left', ll);
		}
		else {
			var ll = _fs.handleMin.position().left;
		}

		// Drag max handle
		if(_fs.handleMax.data('isdrag')===true) {
			isDrag = true;
			var pos = Math.ceil(ev.pageX-_fs.bar.position().left);
			var lu = Math.min(Math.max(_fs.handleMin.position().left+hw, pos), lMax);
			lu = Math.min(Math.ceil(lu/_fs.snap)*_fs.snap, lMax);
			if(_fs.type=='option') {
				lu -= lu==lMax ? 0 : hw;
			}
			_fs.handleMax.css('left', lu);
		}
		else {
			var lu = _fs.handleMax.position().left;
		}

		// Set range input values
		if(isDrag && _fs.type=='range') {
			_fs.lowerInput.val(_fs.round(_fs.lower + ((_fs.upper-_fs.lower)*(ll/lMax))));
			_fs.upperInput.val(_fs.round(_fs.lower + ((_fs.upper-_fs.lower)*(lu/lMax))));
		}

		// Set selected options
		if(isDrag && _fs.type=='option') {
			var a = Math.floor(ll/_fs.snap);
			var b = Math.floor(lu/_fs.snap);
			var options = _fs.optionInput.find('option');
			for(var i=0; i<options.length; i++) {
				$(options[i]).attr('selected', i>=a && i<=b ? 'selected' : '');
			}
		}
	});
	this.handleMin.mousedown(function(ev) {
		$(this).data('isdrag', true);
		$(this).focus();
		_fs.selectable(this, false);
		return false;
	});
	this.handleMax.mousedown(function(ev) {
		$(this).data('isdrag', true);
		$(this).focus();
		_fs.selectable(this, false);
		return false;
	});
	$(document.body).mouseup(function() {
		_fs.handleMin.data('isdrag', false);
		_fs.handleMax.data('isdrag', false);
		_fs.selectable(this, true);
		//$(this).focus().blur();
	});
}

FilterSlider.prototype.setHandlesFromInputs = function() {
	var bw = this.bar.width();
	var hw = this.handleMin.width();

	if(this.type=='range') {
		this.handleMin.css('left', Math.floor(bw*(this.lowerInput.val()/(this.upper-this.lower))));
		this.handleMax.css('left', Math.ceil(bw*(this.upperInput.val()/(this.upper-this.lower)))-hw);
	}
	else if(this.type=='option') {
		var opts = this.optionInput.find('option');
		var foundMin = null, foundMax = null;
		for(var i=0; i<opts.length; i++) {
			if(foundMin===null && $(opts[i]).attr('selected')) {
				foundMin = i;
			}
			if(foundMin!==null && $(opts[i]).attr('selected')) {
				foundMax = i;
			}
		}
		this.handleMin.css('left', Math.ceil(foundMin*this.snap));
		this.handleMax.css('left', Math.floor((foundMax+1)*this.snap)-hw+2);
	}
}

FilterSlider.prototype.round = function(v) {
	return Math.round(v*100)/100;
};

FilterSlider.prototype.selectable = function( elem, bool ){ 

	if ( !elem ) return; // maybe element was removed ? 
	elem.unselectable = bool ? "off" : "on"; // IE
	elem.onselectstart = function(){ return bool; }; // IE
	if ( elem.style ) elem.style.MozUserSelect = bool ? "" : "none"; // FF
};